import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { aboutData } from '../data/mock';

export default function About() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: 'easeOut' }
    }
  };

  return (
    <section ref={ref} className="relative py-32 overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-full bg-gradient-to-b from-[#2A4A85]/5 to-transparent" />

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="max-w-6xl mx-auto"
        >
          {/* Section Label */}
          <motion.div variants={itemVariants} className="text-[#6B8FCC]/70 font-mono text-sm mb-4 tracking-widest">
            ABOUT US
          </motion.div>

          {/* Title */}
          <motion.h2
            variants={itemVariants}
            className="text-5xl md:text-7xl font-black mb-8 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent"
          >
            {aboutData.title}
          </motion.h2>

          {/* Description */}
          <motion.p
            variants={itemVariants}
            className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-20 max-w-4xl"
          >
            {aboutData.description}
          </motion.p>

          {/* Stats Grid - 2 cards, centered */}
          <motion.div
            variants={containerVariants}
            className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl"
          >
            {aboutData.stats.map((stat, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="group relative"
              >
                {/* Glass Card */}
                <div className="relative p-8 rounded-2xl bg-white/5 backdrop-blur-xl border border-white/10 hover:border-[#4A6FA5]/50 transition-all duration-500 hover:bg-white/10 hover:scale-105">
                  {/* Gradient Overlay on Hover */}
                  <div className="absolute inset-0 bg-gradient-to-br from-[#4A6FA5]/10 to-[#2A4A85]/10 opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity duration-500" />

                  <div className="relative z-10">
                    {/* Value */}
                    <div className="text-4xl md:text-5xl font-black mb-2 bg-gradient-to-r from-[#6B8FCC] to-blue-400 bg-clip-text text-transparent">
                      {stat.value}
                    </div>

                    {/* Label */}
                    <div className="text-sm text-gray-400 font-medium tracking-wide">
                      {stat.label}
                    </div>
                  </div>

                  {/* Corner Accent */}
                  <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-[#4A6FA5]/20 rounded-tr-2xl group-hover:border-[#4A6FA5]/60 transition-colors duration-500" />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
